import type { RouteRecordRaw } from 'vue-router'

export const redirects: RouteRecordRaw[] = []

export const routes: RouteRecordRaw[] = [
]
